/* eslint-disable */
import { combineReducers } from 'redux';
import events from '../components/controls/filters/filters_reducers';
import current_user from '../components/user/user_reducers';
import standings from '../components/standings/standings_reducer';

export default combineReducers({ events, current_user, standings });
